import { isEqual } from 'lodash';
import { IFilterComparator, DateRangeFilterModel } from '../../filter-types';

export class DateRangeModelComparator
  implements IFilterComparator<DateRangeFilterModel> {
  applyFilterOptions() {
    // do nothing
  }

  hasValidDiff(
    grid: Partial<DateRangeFilterModel>,
    store: DateRangeFilterModel
  ): boolean {
    if (!grid) {
      return true;
    }
    return !(
      isEqual(grid.from, store.from) &&
      isEqual(grid.to, store.to) &&
      isEqual(grid.isFilterActive, store.isFilterActive)
    );
  }
}
